function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;


/*****************
 ** WEBPACK FOOTER
 ** ./~/i18next-xhr-backend/~/@babel/runtime/helpers/classCallCheck.js
 ** module id = 1165
 ** module chunks = 0
 **/